module.exports = __webpack_public_path__ + "static/media/OverheadSquatfemale.18ed5249.svg";